import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            nombre: "",     
            codigo: "",
            leyenda: "",
            tipoDefecto: 0, 
            postVariables: ['nombre', 'codigo', 'leyenda', 'tipoDefecto'],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }


    resetForm() {
        this.setState({
            id: null,
            nombre: "",     
            codigo: "",
            leyenda: "",
            tipoDefecto: 0, 
            errors: [],
        });
    }

    getData() {
        const { postVariables} = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });

        return data;
    }

    setData(data) {
        if (data.success) {
            this.setState({
                id: data.id,
                nombre: data.nombre,
                codigo: data.codigo, 
                leyenda: data.leyenda,
                tipoDefecto: data.tipoDefecto,  
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nueva Cuenta",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "La Cuenta ha sido creada con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Cuenta",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "La Cuenta ha sido editada con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Cuenta",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Cuenta",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "La Cuenta ha sido eliminada con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    render() {
        const { nombre , codigo, leyenda, tipoDefecto} = this.state;
        let vars = this.modalVars();
        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.caja.cuentas : null)}
                submitUrl={(vars.submitType ? api.caja.cuentas : null)}
                submitType={vars.submitType}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                className="ui-paradigma-modal"
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}
            >
                <section className="ui-modal-section">
                    <p className="ui-section-label">Identificación</p>
                    <div className="ui-form-grid">
                        <ParadigmaLabeledInput
                            disabled={vars.disabled}
                            md={[12, 12]}
                            classNames={["ui-field-label-col", "ui-field-control-col"]}
                            maxLength={5}
                            type={'integer'}
                            label={"Código"}
                            value={codigo}
                            onChange={(e) => this.onChangeField('codigo', e.target.value)}
                            onBlur={() => this.onChangeField('codigo', codigo.padStart(5, '0'))}
                            onFocus={(e) => e.target.select()}
                            error={() => this.getError('codigo')}
                        />

                        <ParadigmaLabeledInput
                            disabled={vars.disabled}
                            md={[12, 12]}
                            classNames={["ui-field-label-col", "ui-field-control-col"]}
                            maxLength={150}
                            label={"Nombre"}
                            value={nombre}
                            onChange={(e) => this.onChangeField('nombre', e.target.value)}
                            error={() => this.getError('nombre')}
                        />

                        <ParadigmaLabeledInput
                            disabled={vars.disabled}
                            md={[12, 12]}
                            classNames={["ui-field-label-col", "ui-field-control-col"]}
                            label={"Tipo por Defecto"}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    disabled={vars.disabled}
                                    url={undefined}
                                    optionDefault={[{nombre: 'Ingreso', id: 0}, {nombre: 'Egreso', id: 1}]}
                                    value={tipoDefecto}
                                    onChange={data => (data) ? (this.onChangeField('tipoDefecto', data.id)) : (this.onChangeField('tipoDefecto', 0))}
                                    clearable={false}
                                />
                            }
                            error={() => this.getError('tipoDefecto')}
                        />

                        <div className="ui-span-2">
                            <ParadigmaLabeledInput
                                disabled={vars.disabled}
                                md={[12, 12]}
                                classNames={["ui-field-label-col", "ui-field-control-col"]}
                                label={"Leyenda"}
                                type="textarea"
                                value={this.state.leyenda}
                                onChange={e => this.onChangeField('leyenda', e.target.value)}
                            />
                        </div>
                    </div>
                </section>

            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Caja/Cuentas/Modal.js